import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import "./index.css";
import AudioPlayer from "react-custom-audio-player";
import Search from "../../Elements/Search/Search";
import OptSearch from "../../Elements/OptSearch";
import OptSearch6 from "../../Elements/OptSearch6";
import RightIconMenu from "../RightIconMenu";
import $ from "jquery";
import OptSearch_SingleInputText from "../OptSearch_SingleInputText/OptSearch";
import PaginationList from "../PaginationList"

export default class View_type_14 extends Component {
    constructor(props) {
        super(props);
        //console.log("View_type_14 ", props);
        var data = Array.isArray(props.data) ? props.data[0] : props.data;
        this.state = {
            data: data,
            r_menu: data.right_menu ? data.right_menu : [],
            r_menu_serach: data.right_menu_serach ? data.right_menu_serach : [],
            title: data.title ? data.title : "",
            tabs: data.tabs ? props.data.tabs : [],
            content: data.content ? data.content : [],
            read_more: data.read_more ? data.read_more : [],
            list: data.list ? data.list : [],
            content_title: data.content_title ? data.content_title : null,
            rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
            player: [],
            audioTrack: {
                id: false,
            },
            counter: data.items_per_page ? data.items_per_page : null,
            counterX: 1,
            pagination_item: data.pagination_list ? data.pagination_list : null,
            sortedBy: false,
            lightboxOn: false,
            lightboxIndex: 0,
            lightboxImages: [],
        };
    }

    createMarkup(item) {
        return { __html: item };
    }

    render() {
        console.log("aaa", this.props)
        function audioFix(audio) {
            $(".ivrplaybtn").click(function () {
                $(".play_pause_button").each(function () {
                    if (!$(this).hasClass("paused")) {
                        $(this).trigger("click");
                    }
                })
            })
        }


        $(document).ready(function () {
            if (window.location.href.indexOf("chopin/list/") > -1) {
                $(".vt2.vt14.RightMenu").remove();
            }
        });

        const {
            description,
            title_image,
            table,
            pagination,
            border_bottom
        } = this.props.data;

        var _this = this;
        var var1 = this.state.data.title ? this.state.data.title : "";

        var calendar = this.state.calendar ? (
            <Link to={this.state.calendar.url}>
                <div className="vt2-calendar">
                    <img className="vt2-calendar-img" src={this.state.calendar.img} />
                    {this.state.calendar.text}
                </div>
            </Link>
        ) : null;
        let flex = null;

        const dataLabel = window.location.href.indexOf("/en/") > -1 ? "Date" : "Data";
        const musicLabel = window.location.href.indexOf("/en/") > -1 ? "Music notes" : "Partytury";
        const galleryLabel = window.location.href.indexOf("/en/") > -1 ? "Object gallery" : "Galeria obiektów";
        const searchArea = this.state.data.optional_search_area_2 ? (<OptSearch_SingleInputText />) : (null);
        const searchArea6 = this.state.data.optional_search_area_6 ? (<OptSearch6 {...this.state.data} />) : (null);


        let borderBottomClass = null;

        if (border_bottom) {
            borderBottomClass = {
                borderBottom: "2px solid #c1c1c1"
            };
        }

        const paginationList = this.state.data.pagination_list ? <PaginationList {...this.state.data} sortedBy={this.state.sortedBy} /> : null;

        const createGallery = (array, item) => {
            this.setState({
                lightboxOn: true,
                lightboxImages: array,
                lightboxIndex: item,
            })
            //console.log("Array to:", array, "image to:", item)
        }

        // Gallery function
        const closeLightbox = () => {
            this.setState({
                lightboxOn: false
            })
        }

        return (
            <div className="vt2">
                <div className="vt2 left col-xs-12 col-sm-12 col-md-8 col-lg-9">
                    <div className="vt2 row">
                        <div className="vt14-content vt2-title">



                            {this.props.data.border_bottom ? (
                                <div
                                    // style={borderBottomClass}
                                    className="vt2-title-name vt14-title-name pagination_list-pageTitle"
                                    dangerouslySetInnerHTML={{ __html: var1 }}
                                />
                            ) : (
                                <div
                                    className="vt2-title-name vt14-title-name pagination_list-pageTitle"
                                    dangerouslySetInnerHTML={{ __html: var1 }}
                                />
                            )}
                            {/* {console.log(this.props.data)} */}
                            {this.props.data.single_list_content ? (

                                <div>
                                    {this.state.data.name ? (
                                        <div className="single_list_head-line">
                                            <h3>{this.state.data.name}</h3>
                                        </div>
                                    ) : null}

                                    {this.state.data.sender[0] && this.state.data.sender[0].length ? (
                                        <div className="single_list_head-line">
                                            <div><strong>{this.state.data.sender ? (this.state.data.sender.label) : (null)}</strong></div>
                                            {this.state.data.sender[0].map(function (sender, senderIndex) {
                                                return (
                                                    <span key={senderIndex}>
                                                        {sender.url && sender.url.length ? (
                                                            <span>
                                                                {senderIndex > 0 ? ", " : ""}
                                                                <a href={sender.url}>
                                                                    {sender.name}
                                                                </a>
                                                            </span>

                                                        ) : (
                                                            <span>
                                                                {senderIndex > 0 ? ", " : ""}{sender.name}
                                                            </span>
                                                        )}
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    ) : null}

                                    {this.state.data.addressee[0] && this.state.data.addressee[0].length ? (
                                        <div className="single_list_head-line">
                                            <div><strong>{this.state.data.addressee ? (this.state.data.addressee.label) : (null)}</strong></div>
                                            {this.state.data.addressee[0].map(function (addressee, addresseeIndex) {
                                                return (
                                                    <span key={addresseeIndex}>
                                                        {addressee.url && addressee.url.length ? (
                                                            <span>
                                                                {addresseeIndex > 0 ? ", " : ""}
                                                                <a href={addressee.url}>
                                                                    {addressee.name}
                                                                </a>
                                                            </span>

                                                        ) : (
                                                            <span>
                                                                {addresseeIndex > 0 ? ", " : ""}{addressee.name}
                                                            </span>
                                                        )}
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    ) : null}


                                    <div className="single_list_head-line">
                                        <span><strong>{this.state.data.data_start ? (dataLabel) : (null)}</strong></span>
                                        {this.state.data.addressee ? (<p dangerouslySetInnerHTML={{ __html: this.state.data.data_start }} />) : (null)}
                                    </div>

                                    <div className="single_list_head-line">
                                        <span><strong>{this.state.data.source.label ? (this.state.data.source.label) : (null)}</strong></span>
                                        {this.state.data.source.source ? (<p>{this.state.data.source.source}</p>) : null}
                                    </div>

                                    <div className="single_list_head-line">
                                        <span><strong>{this.state.data.txt ? (this.state.data.txt.label) : (null)}</strong></span>
                                        {this.state.data.txt ? (<p dangerouslySetInnerHTML={{ __html: this.state.data.txt.txt }} />) : (null)}
                                    </div>

                                    {this.state.data.original_txt && this.state.data.original_txt.original_txt ? (
                                        <div className="single_list_head-line">
                                            <span><strong>{this.state.data.original_txt && this.state.data.original_txt.original_txt ? (this.state.data.original_txt.label) : (null)}</strong></span>
                                            {this.state.data.original_txt ? (<p dangerouslySetInnerHTML={{ __html: this.state.data.original_txt.original_txt }} />) : (null)}
                                        </div>
                                    ) : null}


                                </div>
                            ) : null}

                            {this.state.data.blocks ?
                                (this.state.data.blocks.map((block, index) => {
                                    return (
                                        <div className="block__text--wrapper">
                                            <h3 className="title" dangerouslySetInnerHTML={{ __html: block.label }} />
                                            <div className="text" dangerouslySetInnerHTML={{ __html: block.txt }} />
                                        </div>)
                                }))
                                : null}

                            {this.state.data.humdrum_data && this.state.data.humdrum_data.length ? (
                                <div className="block__text--wrapper">
                                    <h3 className="title">{musicLabel}</h3>
                                    <ul>
                                        {this.state.data.humdrum_data.map((item, index) =>
                                            <li key={index}><a target="_blank" href={item.url}>{item.name}</a></li>
                                        )}
                                    </ul>
                                </div>
                            ) : null}


                            {this.state.data.galleries && this.state.data.galleries.length ? (
                                <div className="block__text--wrapper" id="custom-gallery">
                                    <h3 className="title">{galleryLabel}</h3>
                                    <ul>
                                        {this.state.data.galleries.map((gallery, index) => {
                                            return (
                                                <li key={index}>
                                                    <a href={gallery.url}>
                                                        {gallery.name}
                                                    </a>
                                                </li>
                                            )
                                        })}

                                    </ul>
                                </div>
                            ) : null}

                            {title_image && (
                                <div className="vt14 title_image">
                                    {this.props.data.title_description && (
                                        <h2 className="vt14 title-image__description">
                                            {this.props.data.title_description}
                                        </h2>
                                    )}
                                    <img src={title_image} />
                                </div>
                            )}
                            {this.props.data.schedule && (
                                <div className="vt14 schedule">
                                    {this.props.data.starting_page ? (
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={_this.createMarkup(description)}
                                        />
                                    ) : (
                                        <div
                                            className="vt2_chopin_list__description"
                                            dangerouslySetInnerHTML={_this.createMarkup(description)}
                                        />
                                    )}

                                    {this.props.data.schedule.map((elem, key) => {
                                        return (
                                            <div className="row vt14 schedule__wrapper" key={key}>
                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Gatunek:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.genre}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Tonacja:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.mood}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Opus:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.opus}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Data Powstania:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.date_start}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Wg Paderewskiego:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.wg_paderewskiego}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Wg Turb:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.wg_turbo}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Obsada:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.cast}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Utwór dedytkowany:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.dedicated}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Zródla rękopismienne:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
                                                    {" "}
                                                    {elem.sources}
                                                </div>

                                                <div className="col-sm-5 col-xs-12 vt14 schedule__border">
                                                    {" "}
                                                    Pierwodruki:
                                                </div>
                                                <div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right schedule__border--pierwodruki">
                                                    {" "}
                                                    <span
                                                        style={{
                                                            display: "block"
                                                        }}
                                                    >
                                                        {elem.editions}
                                                    </span>
                                                    <span
                                                        style={{
                                                            display: "block"
                                                        }}
                                                    >
                                                        {elem.editions}
                                                    </span>
                                                    <span
                                                        style={{
                                                            display: "block"
                                                        }}
                                                    >
                                                        {elem.editions}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            {table && (
                                <div className="vt14 simple-container">
                                    {table.map((elem, key) => {
                                        return (
                                            <div key={key} className={`table-row table-box${key} simple-item`}>
                                                <Link to={elem.url}>
                                                    {elem.name}
                                                </Link>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            {!this.state.data.schedule && (
                                <div
                                    className=""
                                    style={{
                                        marginBottom: "25px"
                                    }}
                                    dangerouslySetInnerHTML={_this.createMarkup(description)}
                                />
                            )}

                            <div className="vt2-title-tabs">
                                {this.state.tabs.map(function (object, i) {
                                    if (object.active === 1) {
                                        return (
                                            <div
                                                className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                                                key={i}
                                            >
                                                <div className="vt2 tab-checked">
                                                    <Link to={"/" + object.link}>{object.title}</Link>
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div
                                                className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                                                key={i}
                                            >
                                                <Link to={"/" + object.link}>{object.title}</Link>
                                            </div>
                                        );
                                    }
                                })}
                            </div>

                            {
                                this.state.data.optional_search_area ?
                                    (<OptSearch {...this.state.data} />)
                                    :
                                    (null)
                            }
                            {searchArea6}
                            {searchArea}
                            {paginationList}
                        </div>
                        <div className="vt2-content">
                            <div
                                dangerouslySetInnerHTML={_this.createMarkup(this.state.content)}
                            />
                        </div>

                        <div>
                            {!this.props.data.content &&
                                !this.props.data.single_list_content && !this.state.data.view_type ? (
                                <div className="flex-container">
                                    {" "}
                                    {this.state.data.list ?
                                        (
                                            this.state.data.list.map(function (object, i) {
                                                // console.log("tlo", object.img);
                                                if (object.cols == 3) {
                                                    var color = "rgba(0,156,178,0.5)";

                                                    if (
                                                        object !== "undefined" &&
                                                        object.hasOwnProperty("img") &&
                                                        !object.hasOwnProperty("text")
                                                    ) {
                                                        var img = object.img;
                                                        var thumbnail = (
                                                            <div
                                                                style={{
                                                                    flex: 1,
                                                                    backgroundColor: color,
                                                                    padding: 10,
                                                                    color: "white",
                                                                    position: "absolute",
                                                                    left: 15,
                                                                    right: 15
                                                                }}
                                                            >
                                                                {object.title}
                                                            </div>
                                                        );
                                                        return (
                                                            <div
                                                                className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                                                key={i}
                                                            >
                                                                <div>
                                                                    {thumbnail}
                                                                    <img src={img} className="vt2 list_image" />
                                                                </div>
                                                            </div>
                                                        );
                                                    } else if (object !== "undefined") {
                                                        var button = null;
                                                        var img = object.img;
                                                        var thumbnail = (
                                                            <div
                                                                className="vt2 middle-thumbnailholder"
                                                                style={{
                                                                    flex: 1,
                                                                    backgroundColor: color,
                                                                    padding: 10,
                                                                    color: "white"
                                                                }}
                                                            >
                                                                {object.title}
                                                            </div>
                                                        );
                                                        var img = (
                                                            <div>
                                                                <img src={img} />
                                                            </div>
                                                        );

                                                        if (typeof object.button !== "undefined") {
                                                            button = (
                                                                <div className="vt2 middle-addelem">
                                                                    <Link
                                                                        to={object.button.link}
                                                                        className="vt2 more_button"
                                                                    >
                                                                        {" "}
                                                                    </Link>
                                                                </div>
                                                            );
                                                        }

                                                        if (i == 0) {
                                                            return (
                                                                <div
                                                                    className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
                                                                    key={i}
                                                                >
                                                                    <div className="vt2 row">
                                                                        <Link to={object.button.link}>
                                                                            <div
                                                                                className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box test123"
                                                                            // style={{
                                                                            // 	backgroundImage: `url(${object.img})`,
                                                                            // 	height: "150px"
                                                                            // }}
                                                                            >
                                                                                {img}
                                                                                {/* <p>

																								{object.audio}
																							</p> */}
                                                                            </div>
                                                                        </Link>
                                                                        <div>
                                                                            <Link to={object.button.link}>
                                                                                <div
                                                                                    className="ChopinLists__text-button"
                                                                                    dangerouslySetInnerHTML={_this.createMarkup(
                                                                                        object.text
                                                                                    )}
                                                                                />
                                                                            </Link>
                                                                            {/* {button} */}
                                                                            {object.audio && (
                                                                                <span className="audio__wrapper" onClick={audioFix}>
                                                                                    <AudioPlayer
                                                                                        controls={true}
                                                                                        src={object.audio}
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                            <Link to={object.button.link}>
                                                                                <div
                                                                                    className="ChopinLists__sub-title"
                                                                                    dangerouslySetInnerHTML={_this.createMarkup(
                                                                                        object.sub_title
                                                                                    )}
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            );
                                                        } else {
                                                            return (
                                                                <div
                                                                    className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center flex-item"
                                                                    key={i}
                                                                >
                                                                    <div className="vt2 row">
                                                                        <Link to={object.button.link}>
                                                                            <div
                                                                                className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box test321"
                                                                            // style={{
                                                                            // 	height: "150px",
                                                                            // 	background: `url(${object.img})`
                                                                            // }}
                                                                            >
                                                                                {img}
                                                                            </div>
                                                                        </Link>
                                                                        <div>
                                                                            <Link to={object.button.link}>
                                                                                <div
                                                                                    className="ChopinLists__text-button"
                                                                                    dangerouslySetInnerHTML={_this.createMarkup(
                                                                                        object.text
                                                                                    )}
                                                                                />
                                                                            </Link>
                                                                            {/* {button} */}
                                                                            {object.audio && (
                                                                                <span className="audio__wrapper">
                                                                                    <AudioPlayer
                                                                                        src={object.audio}
                                                                                        controls={true}
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                            <Link to={object.button.link}>
                                                                                <div
                                                                                    className="ChopinLists__sub-title"
                                                                                    dangerouslySetInnerHTML={_this.createMarkup(
                                                                                        object.sub_title
                                                                                    )}
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                } else {
                                                    var color = "rgba(0,156,178,0.5)";

                                                    if (
                                                        object !== "undefined" &&
                                                        object.hasOwnProperty("img") &&
                                                        !object.hasOwnProperty("text")
                                                    ) {
                                                        var img = object.img;
                                                        var thumbnail = (
                                                            <div
                                                                style={{
                                                                    flex: 1,
                                                                    backgroundColor: color,
                                                                    padding: 10,
                                                                    color: "white",
                                                                    position: "absolute",
                                                                    left: 15,
                                                                    right: 15
                                                                }}
                                                            >
                                                                {object.title}
                                                            </div>
                                                        );
                                                        return (
                                                            <div
                                                                className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                                                key={i}
                                                            >
                                                                <div>
                                                                    {thumbnail}
                                                                    <img src={img} className="vt2 list_image" />
                                                                </div>
                                                            </div>
                                                        );
                                                    } else if (object !== "undefined") {
                                                        var button = null;
                                                        var img = object.img;
                                                        var thumbnail = (
                                                            <div
                                                                className="vt2 middle-thumbnailholder"
                                                                style={{
                                                                    flex: 1,
                                                                    backgroundColor: color,
                                                                    padding: 10,
                                                                    color: "white"
                                                                }}
                                                            >
                                                                {object.title}
                                                            </div>
                                                        );
                                                        var img = (
                                                            <div>
                                                                <img src={img} />
                                                            </div>
                                                        );

                                                        if (typeof object.button !== "undefined") {
                                                            button = (
                                                                <div className="vt2 middle-addelem">
                                                                    <Link
                                                                        to={object.button.link}
                                                                        className="vt2 more_button"
                                                                    >
                                                                        {" "}
                                                                    </Link>
                                                                </div>
                                                            );
                                                        }

                                                        if (i == 0) {
                                                            return (
                                                                <div
                                                                    className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
                                                                    key={i}
                                                                >
                                                                    {object.multimedia && (
                                                                        <div>
                                                                            {/* <MultimediaItem {...this.object.multimedia.videos}/> */}
                                                                        </div>
                                                                    )}
                                                                    <div className="vt2 middle-postblock">
                                                                        {img}
                                                                        <div
                                                                            dangerouslySetInnerHTML={_this.createMarkup(
                                                                                object.text
                                                                            )}
                                                                        />
                                                                        {button}
                                                                    </div>
                                                                </div>
                                                            );
                                                        } else {
                                                            return (
                                                                <div
                                                                    className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
                                                                    key={i}
                                                                >
                                                                    <div className="vt2 middle-postblock">
                                                                        {img}
                                                                        <div
                                                                            dangerouslySetInnerHTML={_this.createMarkup(
                                                                                object.text
                                                                            )}
                                                                        />
                                                                        {button}
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                }
                                            })
                                        )
                                        :
                                        (
                                            null
                                        )
                                    }
                                </div>
                            ) : null}
                        </div>
                        {this.props.data.pagination && (
                            <div className="pagination">
                                <ul className="pagination__wrapper">
                                    {this.props.data.pagination.map((elem, index) => {
                                        return (
                                            <li key={index} className="pagination__item">
                                                <NavLink
                                                    exact
                                                    activeClassName="pagination__selected"
                                                    to={elem.url}
                                                >
                                                    {elem.id}
                                                </NavLink>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}

                    </div>

                </div>
                <div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    {this.state.r_menu.length > 2 ? (
                        <div className="vt2 RightMenu">
                            <ul className="vt2 right_menu_items">
                                {this.state.r_menu.map(function (object, i) {
                                    var var4 = object.url ? object.url : "";
                                    var var5 = object.name ? object.name : "";
                                    //console.log("RightMenu", object);
                                    return (
                                        <li className="vt2 left-menuItem" key={i}>
                                            <Link className="vt2 left-menuUnit" to={"/" + var4}>
                                                {var5}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ) : (
                        <div className="vt2 RightMenu vt14 RightMenu">
                            {this.props.data.right_menu_serach_option && (
                                <div>
                                    <span className="vt14 RightMenu__serach-title">
                                        szukaj wg:
                                    </span>
                                    <label className="vt14 RightMenu__serach-label">
                                        <p>Tytuł</p>
                                        <input
                                            className="vt14 RightMenu__serach-input"
                                            type="text"
                                        />
                                    </label>
                                    <ul className="vt2 right_menu_items RightMenu list">
                                        {this.state.r_menu_serach.map(function (object, i) {
                                            var var4 = object.url ? object.url : "";
                                            var var5 = object.name ? object.name : "";
                                            return (
                                                <li className="vt2 RightMenu item" key={i}>
                                                    <Link to={"/" + var4}>{var5}</Link>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}
                            {this.props.data.right_menu_serach_option_input && (
                                <Search
                                    inputHandler={this.inputHandler}
                                    {...this.props} />
                            )}
                            {this.state.rightIconMenu &&
                                <RightIconMenu data={this.state.rightIconMenu} />
                            }
                            {pagination && (
                                <ul className="vt2 right_menu_items RightMenu list">
                                    {pagination.map(function (object, i) {
                                        var var4 = object.url ? object.url : "";
                                        var var5 = object.name ? object.name : "";
                                        //console.log("RightMenu", object);
                                        return (
                                            <li className="vt2 RightMenu item" key={i}>
                                                <Link to={"/" + var4}>{var5}</Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}

                        </div>
                    )}
                    {this.state.data.single_list_image ?
                        (
                            <img src={this.state.data.single_list_image} />
                        )
                        :
                        (
                            null
                        )
                    }
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_14/index.js